import { EntregoBaixaSection } from "../fund-baixa-resolution/components/entrego-baixa-section";
import { useEntregoBaixa } from "../fund-baixa-resolution/hooks/use-entrego-baixa";

export default function EntregoBaixaResolution() {
  const {
    opsList,
    baixaList,
    selectedOps,
    setSelectedOps,
    isLoadingOps,
    isLoadingBaixas,
    startDoc,
    submitDb,
    isStartingDoc,
    isSubmittingDb,
  } = useEntregoBaixa();

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-foreground">
          Entrego Baixa
        </h1>
        <p className="text-muted-foreground mt-1">
          Resolver pendências das baixas de Entrego
        </p>
      </div>

      <EntregoBaixaSection
        opsList={opsList}
        baixaList={baixaList}
        selectedOps={selectedOps}
        onSelectionChange={setSelectedOps}
        isLoadingOps={isLoadingOps}
        isLoadingBaixas={isLoadingBaixas}
        onStartDoc={startDoc}
        onSubmitDb={submitDb}
        isStartingDoc={isStartingDoc}
        isSubmittingDb={isSubmittingDb}
      />
    </div>
  );
}
